<template>
	<div class="text-center">
		<h1 class="h1 font-weight-bold d-none d-lg-block">{{ $t('Igényléseim') }}</h1>

        <div v-if="loading">
            <content-loader
                    :width="730"
                    :height="694"
                    :speed="2"
                    primaryColor="#ffffff"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="6" ry="6" width="730" height="78" /> 
                    <rect x="0" y="88" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="176" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="264" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="352" rx="6" ry="6" width="730" height="78" />
            </content-loader>
        </div>
        <div v-if="!loading && !requests.length">
            <div class="h2 text-left d-block d-lg-none">{{$t('Igényléseim')}}</div>
            <div class="shadow-block text-center font-weight-bold">{{ $t('Önnek még nem volt járat igénylése.') }}</div>
        </div>
		<div v-else-if="!loading">
			<h2 class="h2 text-left">{{$t('Aktuális igénylések')}}</h2>
			<div
				class="shadow-block text-center font-weight-bold"
				v-if="!actualRequests.length"
			>{{ $t('Önnek jelenleg nincs aktuális igénylése.') }}</div>
			<div v-else>
				<div
					class="shadow-block shadow-block--with-buttons mb-4"
					v-for="(req) in actualRequests"
					:key="req.id"
				>
					<div class="form-row align-items-center">
						<div class="col text-left">
							<div class="form-row align-items-center py-1">
								<div class="shadow-block__pin col-auto">
									<inline-svg :src="require('@/assets/icons/previous.svg')"></inline-svg>
								</div>
								<div class="col">
									<div class="color-grey3 text-smaller">{{travelDateString(req.travelDate)}}</div>
									<div>{{req.arrivalTime | arrivalTime}}</div>
								</div>
							</div>

							<div class="form-row align-items-center py-1">
								<div class="shadow-block__pin col-auto">
									<inline-svg :src="require('@/assets/icons/pin-filled.svg')"></inline-svg>
								</div>
								<div class="col">
                  <RouteBadge
                      v-if="req.route"
                      :route-id="req.route.routeId"
                      :route-name="req.route.routeShortName"
                      :route-color="req.route.routeColor"
                      :route-text-color="req.route.routeTextColor"
                      small
                      class="d-inline-flex pr-2"
                  />
									<span class="d-inline-flex align-items-center shadow-block__pin" v-if="req.fromStop || req.toStop"><template v-if="req.fromStop">{{req.fromStop.name}}</template> <template v-if="req.toStop"><inline-svg  class="routes__direction-icon mx-2" :src="require('@/assets/icons/direction-right.svg')" ></inline-svg> {{req.toStop.name}}</template></span>
								</div>
							</div>
						</div>
						<div class="shadow-block__buttons shadow-block__pin">
							<button
								v-if="req.favorite"
                                :aria-label="$t('Kedvenc')"
								@click="setFavorite(req,false)"
								class="shadow-block__button h-50"
							>
								<inline-svg :src="require('@/assets/icons/favourite-filled.svg')"></inline-svg>
							</button>
							<button :aria-label="$t('Kedvenc')" v-else @click="setFavorite(req,true)" class="shadow-block__button h-50">
								<inline-svg :src="require('@/assets/icons/favourite.svg')"></inline-svg>
							</button>
							<button :aria-label="$t('Visszavonás')" @click="cancelRequest(req)" class="shadow-block__button h-50">
								<inline-svg :src="require('@/assets/icons/delete.svg')"></inline-svg>
							</button>
						</div>
					</div>
				</div>
			</div>

			<h2 class="h2 text-left">{{$t('Korábbi igénylések')}}</h2>
			<div
				class="shadow-block text-center font-weight-bold"
				v-if="!pastRequests.length"
			>{{ $t('Önnek nincs korábbi igénylése.') }}</div>
			<div v-else>
				<div
					class="shadow-block shadow-block--with-buttons mb-4"
					v-for="(req) in pastRequests"
					:key="req.id"
				>
					<div class="form-row align-items-center">
						<div class="col text-left">
							<div class="form-row align-items-center py-1">
								<div class="shadow-block__pin col-auto">
									<inline-svg :src="require('@/assets/icons/previous.svg')"></inline-svg>
								</div>
								<div class="col">
									<div class="color-grey3 text-smaller">{{travelDateString(req.travelDate)}}</div>
									<div>{{req.arrivalTime | arrivalTime}}</div>
								</div>
							</div>

							<div class="form-row align-items-center py-1">
								<div class="shadow-block__pin col-auto">
									<inline-svg :src="require('@/assets/icons/pin-filled.svg')"></inline-svg>
								</div>
								<div class="col">
									<RouteBadge
                      v-if="req.route"
                      :route-id="req.route.routeId"
                      :route-name="req.route.routeShortName"
                      :route-color="req.route.routeColor"
                      :route-text-color="req.route.routeTextColor"
                      small
                      class="d-inline-flex pr-2"
                  />
									<span class="d-inline-flex align-items-center shadow-block__pin" v-if="req.fromStop || req.toStop"><template v-if="req.fromStop">{{req.fromStop.name}}</template> <template v-if="req.toStop"><inline-svg class="routes__direction-icon mx-2" :src="require('@/assets/icons/direction-right.svg')" ></inline-svg> {{req.toStop.name}}</template></span>
								</div>
							</div>
						</div>
						<div class="shadow-block__buttons shadow-block__pin">
							<button
								v-if="req.favorite"
                                :aria-label="$t('Kedvenc')"
								@click="setFavorite(req,false)"
								class="shadow-block__button h-100"
							>
								<inline-svg :src="require('@/assets/icons/favourite-filled.svg')"></inline-svg>
							</button>
							<button :aria-label="$t('Kedvenc')" v-else @click="setFavorite(req,true)" class="shadow-block__button h-100">
								<inline-svg :src="require('@/assets/icons/favourite.svg')"></inline-svg>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getUserRequestsUsingGET, deleteMyRequestUsingDELETE, setRequestFavoriteUsingPUT } from "@/api";
import { DateTime } from 'luxon';
import Vue from 'vue'
import RouteBadge from '@/components/RouteBadge.vue';
export default {
	name: "Requests",
	components: {
		RouteBadge
	},
	data() {
		return {
			loading: true,
			requests: [],
		};
	},
	computed: {
		actualRequests: function () {
			if (!this.requests.length) return [];
			return this.requests.filter((e) => {
                let requestDt = DateTime.fromISO(DateTime.fromISO(e.travelDate,{setZone: true}).toISODate() + "T" + e.arrivalTime);
                let nowDt = DateTime.local();

                return requestDt > nowDt;
            });
		},
		pastRequests: function () {
			if (!this.requests.length) return [];
			return this.requests.filter((e) => {
                let requestDt = DateTime.fromISO(DateTime.fromISO(e.travelDate,{setZone: true}).toISODate() + "T" + e.arrivalTime);
                let nowDt = DateTime.local();

                return requestDt < nowDt;
            });
		},
	},
	methods: {
		setFavorite: function (req, favorite) {
			if (!favorite) {
				this.$swal({
					title: this.$t("Eltávolítás"),
					text: this.$t("Biztosan eltávolítod a kedvencek közül?"),
					imageUrl: window.swalInfo,
					confirmButtonText: this.$t("Törlés"),
					cancelButtonText: this.$t("Mégse"),
					showCancelButton: true,
					customClass: {
						confirmButton: "button button--blue button--swal",
						cancelButton: "button button--swal",
						title: "text-biggest font-weight-bold",
						actions: "swal2-confirm-actions",
					},
				}).then((result) => {
					if (result.value) {
						setRequestFavoriteUsingPUT({
							demandRequestFavoriteVm: {
								favorite: false,
								demandRequestId: req.id,
							},
						}).then((response) => {
							if (response.status === 200) {
                                req.favorite = false;
							}
						});
					}
				});
			} else {
				setRequestFavoriteUsingPUT({
					demandRequestFavoriteVm: {
						favorite: true,
						demandRequestId: req.id,
					},
				}).then((response) => {
					if (response.status === 200) {
                        req.favorite = true;
                        this.$swal({
                                    title: this.$t("Kedvenc"),
                                    text: this.$t("Az igénylést betettük a kedvencekbe!"),
                                    imageUrl: window.swalSuccess
                                });
					}
				});
			}
		},
		cancelRequest: function (item) {

            let reqestDt = DateTime.fromISO(DateTime.fromISO(item.travelDate,{setZone: true}).toISODate() + "T" + item.arrivalTime).minus({minutes: 15});
            let nowDt = DateTime.local();
            if(nowDt > reqestDt) {
                return this.$swal({
                            title: this.$t("Igénylés visszamondása nem lehetséges"),
                            text: this.$t("Igénylését legkésőbb a járat indulása előtti 15 percig törölheti."),
                            imageUrl: window.swalInfo,
                        });
            }

			this.$swal({
				title: this.$t("Visszavonás"),
				text: this.$t("Biztosan törlöd az igénylést?"),
				imageUrl: window.swalInfo,
				confirmButtonText: this.$t("Törlés"),
				cancelButtonText: this.$t("Mégse"),
				showCancelButton: true,
				customClass: {
					confirmButton: "button button--blue button--swal",
					cancelButton: "button button--swal",
					title: "text-biggest font-weight-bold",
					actions: "swal2-confirm-actions",
				},
			}).then((result) => {
				if (result.value) {
					deleteMyRequestUsingDELETE({ requestId: item.id }).then(
						(response) => {
							if (response.status === 200) {
								this.requests = this.requests.filter(
									(e) => e.id !== item.id
								);
							}
						}
					).catch(err => {
                        this.$swal({
                            title: this.$t("Igénylés törlés"),
                            text: this.$t("Nem sikerült törölni az igénylést. Hiba oka:") + " " + err.errorMessage,
                            imageUrl: window.swalInfo,
                        });
                    });
				}
			});
        },
        travelDateString: function(val) {
            if(typeof val === "undefined" || !val) return "";

            let today = DateTime.local(),
                yesterday = today.minus({days: 1}).toISODate(),
                tomorrow = today.plus({days: 1}).toISODate(),
                selectedDate = DateTime.fromISO(val,{setZone: true}).toISODate();

            if(today.toISODate() === selectedDate) {
                return this.$t('Ma');
            } else if(yesterday === selectedDate) {
                return this.$t('Tegnap');
            } else if(tomorrow === selectedDate) {
                return this.$t('Holnap');
            } else {
                return selectedDate;
            }
        }
	},
	created() {
		getUserRequestsUsingGET({size: 999})
			.then((response) => {
				this.requests = response.data.content;
			})
			.catch((err) => {
				this.$swal({
					title: this.$t("Igényléseim"),
					text: this.$t("Nem sikerült betöltenünk az igényléseket.") + " " + err.errorMessage,
					imageUrl: window.swalError,
				});
			})
			.finally(() => {
				this.loading = false;
			});
    }
};
</script>